export default {
	authenticated: state => state.authenticated,
	isValidating: state => state.isValidating,
	mfa: state => state.mfa,
	mfaChallenge: state => state.mfaChallenge,
	mfaEnforcementRequired: state => state.mfa.enforcementRequired,
	tokens: state => state.tokens,
	userStatistics: state => state.userStatistics,
	user: state => state.user,
	selectingDepartmentId: state => state.selectingDepartmentId,
	department: state => {
		return state.user.departments.find(
			department => department.id === state.user.selectedDepartmentId
		)
	}
}
